import IconButton from '../IconButton/IconButton'
import styles from './SummaryItemComponent.module.scss'

interface ToppingModel {
  name: string
  price: string
}

export interface SummaryItemComponentProps {
  count: number
  name: string
  basePrice?: string
  dishSize?: string
  price: string
  toppings?: ToppingModel[]
  note?: string
  discount?: string
  deletedIngredients?: string[]
  onDelete?: () => void
  onClick?: () => void
}

function SummaryItemComponent(props: SummaryItemComponentProps) {
  const {
    count,
    name,
    basePrice,
    dishSize,
    price,
    toppings,
    note,
    discount,
    deletedIngredients,
    onDelete,
    onClick
  } = props

  const alignContentToTop = !!(
    toppings ||
    note ||
    discount ||
    deletedIngredients
  )
  return (
    <div className={styles.summaryItemContainer}>
      <div
        className={`body-bold-medium ${styles.summaryItemCount}`}
        style={{
          alignSelf: alignContentToTop ? 'flex-start' : 'center',
          cursor: onClick ? 'pointer' : undefined
        }}
        onClick={onClick}
      >
        <p className={`body-bold-medium ${styles.summaryItemCountValue}`}>
          {count}
        </p>
      </div>
      <div
        className={styles.summaryItemAndAdditionalItemWrapper}
        style={{
          justifyContent: alignContentToTop ? 'flex-start' : 'center',
          cursor: onClick ? 'pointer' : undefined
        }}
        onClick={onClick}
      >
        <div className={styles.summaryItemComponent}>
          <div className={styles.summaryItemTextGroup}>
            <p className={`body-bold-medium ${styles.summaryItemDescription}`}>
              {name}
            </p>
          </div>
          <div className={styles.summaryItemTextGroup}>
            <p className={`body-medium ${styles.summaryItemBasePrice}`}>
              {basePrice}
            </p>
            <p className={`body-medium ${styles.summaryItemPrice}`}>{price}</p>
          </div>
        </div>
        {dishSize && (
          <div className={styles.summaryAdditionalItemWrapper}>
            <p
              className={`body-medium ${styles.summaryAdditionalItemDescription}`}
            >
              {`Size: `}
            </p>
            <p
              className={`body-medium ${styles.summaryAdditionalItemDescription}`}
            >
              {dishSize}
            </p>
          </div>
        )}
        {toppings &&
          toppings.map(topping => (
            <div className={styles.summaryAdditionalItemWrapper}>
              <i
                className={`las la-level-up-alt icon-medium ${styles.summaryAdditionalItemIcon} ${styles.rotateIcon}`}
              />
              <p
                className={`body-medium ${styles.summaryAdditionalItemDescription}`}
              >
                {`${topping.name} (${topping.price})`}
              </p>
            </div>
          ))}
        {deletedIngredients &&
          deletedIngredients.map(ingredient => (
            <div className={styles.summaryAdditionalItemWrapper}>
              <i
                className={`las la-times-circle icon-medium ${styles.summaryAdditionalItemIcon}`}
              />
              <p
                className={`body-medium ${styles.summaryAdditionalItemDescription}`}
              >
                {ingredient}
              </p>
            </div>
          ))}
        {!!discount && (
          <div className={styles.summaryAdditionalItemWrapper}>
            <i
              className={`las la-percentage icon-medium ${styles.summaryAdditionalItemIcon}`}
            />
            <p
              className={`body-medium ${styles.summaryAdditionalItemDescription}`}
            >
              {discount}
            </p>
          </div>
        )}
        {!!note && (
          <div
            className={styles.summaryAdditionalItemWrapper}
            style={{ alignItems: 'baseline' }}
          >
            <i
              className={`las la-sticky-note icon-medium ${styles.summaryAdditionalItemIcon}`}
            />
            <p
              className={`body-medium ${styles.summaryAdditionalItemDescription}`}
            >
              {note}
            </p>
          </div>
        )}
      </div>
      {onDelete && (
        <div className={styles.summaryItemActions}>
          <IconButton
            icon="las la-trash icon-large"
            color="primary"
            onClick={onDelete}
            variant="contained"
          />
        </div>
      )}
    </div>
  )
}

export default SummaryItemComponent
